export type ShowcaseBoard = {
  src: string;
  tint: { light: string; dark: string };
};

/** Example signage shown on the showcase TV; each business previews one, cycling by list position. */
export const SHOWCASE_BOARDS: readonly ShowcaseBoard[] = [
  { src: '/boards/heyman.jpg', tint: { light: '#F4E9E2', dark: '#1A1310' } },
  { src: '/boards/gym.jpg', tint: { light: '#E2ECEA', dark: '#0E1716' } },
  { src: '/boards/salon.jpg', tint: { light: '#E4E6F0', dark: '#10131F' } },
];

export function showcaseBoardIndex(organisationIndex: number): number {
  return organisationIndex % SHOWCASE_BOARDS.length;
}
